import useAuthorization from 'FeatureModules/Auth/hooks/useAuthorization';
import { EFeatureFlag } from 'FeatureModules/Auth/hooks/useFeatureFlags';
import React, { FC, PropsWithChildren, ReactElement } from 'react';

type ICanProps = { no: () => ReactElement } & ({ featureFlag: EFeatureFlag } | { rule: string }) &
  PropsWithChildren;

const Can: FC<ICanProps> = ({ children, no, ...props }) => {
  const { authorized } = useAuthorization(props);
  if (!authorized) return no();

  return <>{children}</>;
};

export default Can;
